<div class="base-container">
  <div class="overview-header-row">
    <div class="overview-header-row-inner">
      <div class="overview-title">Select Installation to Commission</div>
      <div class="overview-header-row-right-container">
        Filter:
        <gbc-input-field
          class="overview-header-row-right-container-filter"
          [placeholderTranslationString]="'app-project-name'"
          [(ngModel)]="currentfilter"
          >
        </gbc-input-field>
      </div>
    </div>
  </div>

  <div class="overview-tabs-row">
    @if (activeRoute.queryParams | async; as params) {
      <div class="overview-tabs-row-inner">
        <div class="overview-tab" [ngClass]="{ selected: params.tab === 'missingId' }" (click)="selectTab('missingId')" tabindex="0" (keydown.enter)="selectTab('missingId')">
          Missing IOT-Hub deviceID
        </div>
        <div class="overview-tab" [ngClass]="{ selected: params.tab === 'pendingDevice' }" (click)="selectTab('pendingDevice')" tabindex="0" (keydown.enter)="selectTab('pendingDevice')">
          Pending IOT-Hub device
        </div>
        <div class="overview-tab" [ngClass]="{ selected: params.tab === 'testing' }" (click)="selectTab('testing')" tabindex="0" (keydown.enter)="selectTab('testing')">Undergoing tests</div>
        <div class="overview-tab" [ngClass]="{ selected: params.tab === 'tested' }" (click)="selectTab('tested')" tabindex="0" (keydown.enter)="selectTab('tested')">Completed tests</div>
        <div class="overview-tab" [ngClass]="{ selected: params.tab === 'live' }" (click)="selectTab('live')" tabindex="0" (keydown.enter)="selectTab('live')">Live</div>
      </div>
    }

    @if (configVersions) {
      <div>
        Configuration versions C/CR/IO:<br />{{ configVersions.controlVersion }}/{{ configVersions.controlRuntimeVersion }}/{{
        configVersions.ioVersion
        }}
      </div>
    }
    @if (!configVersions) {
      <div>No configVersions</div>
    }
  </div>
  @if ((activeRoute.queryParams | async).tab; as tab) {
    <div class="installation-page-container">
      @if (
        installations$
        | async
        | sortByName
        | filterByTab: tabToCommissionStates(tab)
        | filterInstallationOnNameOrSerial: currentfilter; as installations
        ) {
        <div
          class="overview-table"
          >
          @if (!installation) {
            <div>
              <!-- If no installations by filter -->
              @if (!requestPending && installations.length === 0 && currentfilter) {
                <div class="overview-table-primary-element">
                  <div class="overview-table-no-filter-matches-title">
                    {{ 'app-page-overview-button-filterproject-nomatches' | translate }}: '{{ currentfilter }}'
                  </div>
                </div>
              }
              @if (requestPending && installations.length === 0) {
                <div class="no-companies-card">Loading Content</div>
              }
              @if (!requestPending && installations.length !== 0) {
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th scope="col">Serial</th>
                      <th scope="col">Name</th>
                      <th scope="col">DeviceId</th>
                      <th scope="col">Version</th>
                      <th scope="col">Config (C/CR/IO)</th>
                    </tr>
                  </thead>
                  <tbody>
                    <!-- | async -->
                    @for (installation of $any(installations | sortBySerialnumber); track installation) {
                      <tr
                        class="commission-table-row-element"
                        (click)="selectInstallation(installation, tab)"
                        tabindex="0" (keydown.enter)="selectInstallation(installation, tab)"
                        >
                        <th scope="row">{{ installation.serialNumber }}</th>
                        <td>{{ installation.name }}</td>
                        <td>{{ installation.deviceId }}</td>
                        <td>{{ installation.version }}</td>
                        @if (installation.configVersionSupportedControl) {
                          <table>
                            <thead>
                              <tr>
                                <th>C</th>
                                <th>CR</th>
                                <th>IO</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td
                    [ngClass]="
                      isVersionOk(configVersions.controlVersion, installation.configVersionSupportedControl) ? 'okVersion' : 'badVersion'
                    "
                                >
                                {{ installation.configVersionSupportedControl }}
                              </td>
                              <td
                    [ngClass]="
                      isVersionOk(configVersions.controlRuntimeVersion, installation.configVersionSupportedControlRuntime)
                        ? 'okVersion'
                        : 'badVersion'
                    "
                                >
                                {{ installation.configVersionSupportedControlRuntime }}
                              </td>
                              <td [ngClass]="isVersionOk(configVersions.ioVersion, installation.configVersionSupportedIo) ? 'okVersion' : 'badVersion'">
                                {{ installation.configVersionSupportedIo }}
                              </td>
                            </tr>
                          </tbody>
                          </table>
                        }
                        @if (!installation.configVersionSupportedControl) {
                          <td></td>
                        }
                      </tr>
                    }
                  </tbody>
                </table>
              }
            </div>
          }
          <!-- Installation Selected -->
          @if (installation) {
            <div>
              @if (!updatingDeviceId && !requestPending) {
                <div>
                  <div class="commission-table-primary-element">
                    <div>Installation: {{ installation.id }}</div>
                    <div>SoftwareVersion: {{ installation.version }}</div>
                    <div>SerialNumber: {{ installation.serialNumber }}</div>
                    <div>State: {{ installation.commissionStatus }}</div>
                    <div>DeviceId: {{ installation.deviceId }}</div>
                    @if (installation.deviceId) {
                      <button [disabled]="requestPending" (click)="resetCommissionProgress()">
                        Reset Commission Progress
                      </button>
                    }
                  </div>
                  <!-- Set DeviceId -->
                  @if (tab === 'missingId') {
                    <div>
                      Update Installation Device Id
                      <div>
                        <input
                          [disabled]="updatingDeviceId"
                          type="text"
                          [formControl]="deviceIdControl"
                          (keyup.enter)="setDeviceIDtoControlValue()"
                          />
                        <button [disabled]="updatingDeviceId" (click)="setDeviceIDtoControlValue()">Set DeviceId</button>
                        @if (checkResult) {
                          <div>{{ checkResult.status }} {{ checkResult.statusText }}</div>
                        }
                      </div>
                      <button (click)="toggleShowSoftwareSelection()">Show Software Selection</button>
                      @if (showSoftwareSelection) {
                        <div class="softwareSelection">
                          <ng-select
                            class="select"
                            [items]="softwareNames$ | async"
                            [multiple]="false"
                            placeholder="Select Software"
                            [(ngModel)]="selectedSoftwarePackageName"
                            (ngModelChange)="getSoftwareVersionsFromData()"
                            >
                          </ng-select>
                          @if (selectedSoftwarePackageName) {
                            <ng-select
                              class="select"
                              bindLabel="version"
                              [items]="filteredSoftewarePackages"
                              [multiple]="false"
                              placeholder="Select Software"
                              [(ngModel)]="selectedSoftwarePackage"
                              >
                            </ng-select>
                          }
                        </div>
                      }
                    </div>
                  }
                  <!-- Check For Device  -->
                  @if (tab === 'pendingDevice') {
                    <div>
                      Check for Connected device:
                      @if (installation.deviceId) {
                        <button [disabled]="requestPending" (click)="checkDeviceOnlineStatus()">Check</button>
                      }
                      @if (checkResult) {
                        <div>{{ checkResult.status }} {{ checkResult.statusText }}</div>
                      }
                    </div>
                  }
                  <!-- Test Device -->
                  @if (tab === 'testing' || tab === 'tested' || tab === 'live') {
                    <div>
                      <!-- if we have a connection status - only happens if device is disconnected -->
                      @if (deviceTwinStatus?.ConnectionStatus == 'Disconnected') {
                        <div>
                          ConnectionStatus:
                          {{ deviceTwinStatus.ConnectionStatus }}
                          @if (installation.deviceId) {
                            <button [disabled]="requestPending" (click)="getInstallationTwinStatus()">
                              Check Device Connetion Status
                            </button>
                          }
                        </div>
                      }
                      <!-- otherwise show -->
                      @if (deviceTwinStatus?.ConnectionStatus != 'Disconnected') {
                        <div>
                          <!-- Show Self test status -->
                          <div class="commission-table-primary-element">
                            <div>
                              SelftestStatus:
                              {{ deviceTwinStatus?.Reported.selfTestStatus }}
                            </div>
                            <div>
                              selfTestErrorMessage:
                              {{ deviceTwinStatus?.Reported.selfTestErrorMessage }}
                            </div>
                          </div>
                          <!-- if we dont have a selftest status or the status wasnt ok -->
                          <div class="commission-table-primary-element">
                            Check Device for SelfTest Status
                            @if (installation.deviceId) {
                              <button [disabled]="requestPending" (click)="getInstallationTwinStatus()">Get Status</button>
                            }
                            @if (checkResult) {
                              <div>{{ checkResult.status }} {{ checkResult.statusText }}</div>
                            }
                          </div>
                          <!-- otherwise we have a device status and it was ok -->
                          @if (deviceTwinStatus) {
                            <div class="commission-table-primary-element">
                              mbusScanning:
                              {{ deviceTwinStatus?.Reported.mbusScanning }} mbusScanResult:
                              {{ deviceTwinStatus?.Reported.mbusScanResult }}
                              Start Test Cycle
                              @if (installation.deviceId) {
                                <button [disabled]="requestPending" (click)="testInstallation('scan_mbus')">scan_mbus</button>
                              }
                              @if (installation.deviceId) {
                                <button [disabled]="requestPending" (click)="testInstallation('scan_geni')">scan_geni</button>
                              }
                              @if (checkResult) {
                                <div>{{ checkResult.status }} {{ checkResult.statusText }}</div>
                              }
                            </div>
                          }
                          <!-- allow approval of device -->
                          @if (deviceTwinStatus) {
                            <div class="commission-table-primary-element">
                              Approve Device as tested
                              @if (installation.deviceId) {
                                <button [disabled]="requestPending" (click)="approveDeviceTests()">Approve</button>
                              }
                              @if (checkResult) {
                                <div>{{ checkResult.status }} {{ checkResult.statusText }}</div>
                              }
                            </div>
                          }
                        </div>
                      }
                    </div>
                  }
                  <!-- Go Live?  -->
                  @if (tab === 'tested') {
                    <div>
                      <div class="commission-table-primary-element">
                        Move device to live
                        @if (installation.deviceId) {
                          <button [disabled]="requestPending" (click)="moveDeviceToLive()">Go Live!</button>
                        }
                        @if (checkResult) {
                          <div>{{ checkResult.status }} {{ checkResult.statusText }}</div>
                        }
                      </div>
                    </div>
                  }
                </div>
              }
              @if (updatingDeviceId || requestPending) {
                <div>
                  @if (updatingDeviceId) {
                    <p>Updating Device Id</p>
                  }
                  @if (requestPending) {
                    <p>Checking for Device in IOTHUB</p>
                  }
                </div>
              }
            </div>
          }
        </div>
      }
    </div>
  }
</div>
